import i18n from 'i18next';
import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext, Field } from 'formik';
import useStyles from './UserItem.styles';
import TextField from '../../../../../../common/components/fields/TextField';
import { IconButton } from '../../../../../../common/components/buttons';
import { Icon } from '../../../../../../common/components/icons';
import Can from '../../../../../../common/contexts/abilityContext';

const UserItem = ({ index, onDelete }) => {
  const classes = useStyles();

  const { values } = useFormikContext();

  const handleDeleteClick = () => onDelete(index);

  return (
    <div className={classes.root}>
      <Field type="hidden" name={`users.${index}.id`} />
      <TextField className={classes.textField} name={`users.${index}.name`} placeholder={i18n.t('client.form.name')} />
      <TextField className={classes.textField} name={`users.${index}.email`} placeholder={i18n.t('client.form.email')} />
      <TextField className={classes.textField} name={`users.${index}.description`} placeholder={i18n.t('client.form.description')} />
      {index !== values.users.length - 1 && (
        <Can do="delete" on={`users.${index}`}>
          <IconButton onClick={handleDeleteClick}>
            <Icon icon="delete" />
          </IconButton>
        </Can>
      )}
    </div>
  );
};

UserItem.propTypes = {
  index: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
};

UserItem.defaultProps = {};

export default UserItem;
